var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.condition)?_c('p',{staticClass:"flex items-center font-small tracking-wide text-red-500 text-xs mb-0 mt-1"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }